import { TTeam } from "@/models/teams.model";
import axios from "@utils/axios-instance";

export const getAll = async (): Promise<TTeam[]> => {
  const response = await axios.get("/users/team");
  return response.data;
};

export const save = async (data: TTeam): Promise<TTeam> => {
  const response = await axios.post("/users/team", data);
  return response.data;
};

export const removeById = async (teamId: number): Promise<void> => {
  await axios.delete(`/users/team/${teamId}`);
};

export const update = async (team: TTeam): Promise<void> => {
  const { id: teamId, ...data } = team;
  await axios.patch(`/users/team/${teamId}`, data);
};

export default {
  getAll,
  save,
  removeById,
  update,
};
